import { apiUri } from '@/constants/Constants';
import { client } from '@/utils/axios/axiosClient';
import { useQuery } from '@tanstack/react-query';
import { type AllValues } from '@/utils/types/types.util';
import { type CorePermissions } from '@/constants/permissions.constant';
import { getAccessToken } from '@/utils/auth';
import { useUrlChecker } from '@/hooks/useUrlChecker';

type GetCorePermissionsResponse = {
  corePermissionStatus: AllValues<typeof CorePermissions>[];
};

export async function getCorePermissions(): Promise<GetCorePermissionsResponse> {
  const requestUrl = apiUri.getCorePermissions;
  const response = await client.get(requestUrl, {
    withCredentials: true,
  });

  return response.data;
}

export function useCorePermissions() {
  // Only the presence of a token gates the query — the value never leaves this
  // hook, since the axios interceptor reads the cookie fresh on every request.
  // So no subscription is needed: startup settles the cookie before first
  // render, a rotation leaves presence unchanged, and logout navigates away.
  const accessToken = getAccessToken();
  const { isPublic } = useUrlChecker();

  const data = useQuery({
    queryKey: ['getCorePermissions'],
    queryFn: () => {
      return getCorePermissions();
    },
    enabled: Boolean(accessToken) && !isPublic,
  });

  return data;
}
